<template>
  <v-card flat>
    <v-card-text style="padding: 0px;margin: 0px;">
      <v-layout row wrap :class="edoClassName + tableName + ' ' + edoClassName" :style="getStyle()">
        <v-flex md12>
          <FixedTableIE :sortDisabled="sortDisabled" :heightSub="subHeight" :ankerBank="bankAnchor" ref="sdTable" :currency="currentCurrency"
                        :maxHeight="maxHeight"
                        :clickEventName="myEventName"
                        :hasAmpel="hasAmpel"
                        :tableName="tableName"
                        :tableTooltips="tableTooltips"
                        :levelST="levelST"
                        :RowBKGFromSource="RowBKGFromSource"
                        :configSuffix="configSuffix"
                        :fixedHeight="fixedHeight"
                        :widthSub="widthSubSet"
                        @btnSupport="onClickbtnSupport"
                        :selected="selected" :tableConfig='tableConfig' class="colorrows"
                        :tableNotComplete="tableNotComplete" :headers="headers" _items="pgresults"></FixedTableIE>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import FixedTableIE from './../../tables/EasyTableIE'

export default {
  name: 'ConfigurationTable',
  components: {FixedTableIE},
  props: ['RowBKGFromSource', 'configSuffix', 'tableTooltips', 'levelST', 'widthSub', 'fixedHeight', 'myStyle', 'hasAmpel', 'sortDisabled', 'data', 'tableName', 'edoClassName', 'heightSub', 'hideHeader', 'maxHeight', 'clickEventName', 'isClickable', 'hideCategories', 'hideHintStars'],
  methods: {
    openTable: function () {
      if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
        this.$refs.sdTable.updateData(this.pgresults, true)
      } else {
        Vue.prototype.$api.hideIdle()
      }
      this.showMe = true
    },
    getStyle: function () {
      if (this.myStyle) return this.myStyle
      return 'padding-top:10px;'
    },
    update: function () {
      if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
        this.$refs.sdTable.updateData(this.pgresults, true)
      }
      this.showMe = true
    },
    open: function (allTablesData) {
      this.showMe = false

      if (this.$refs.sdTable) {
        this.$refs.sdTable.setAlternateTableHeight()
      }

      this.allTablesData = allTablesData
      this.headers = []
      if (!this.allTablesData) return
      Vue.prototype.$api.showIdle()
      var data = null
      if (allTablesData.tables) {
        data = _.clone(allTablesData.tables[this.tableName], true)
      } else {
        data = _.clone(allTablesData.table, true)
      }

      this.result = Vue.prototype.$api.prepareWaimeaTable(data)

      this.pgresults = this.result.rows
      this.headers = this.result.headers
      // this.openTable()
      window.setTimeout(this.openTable, 1001)
    },
    doResize: function () {
      if (this.$refs.sdTable && this.$refs.sdTable.doResize) {
        this.$refs.sdTable.doResize()
      }
    },
    close: function () {
      Vue.prototype.$api.showIdle()
      this.showMe = true
      if (this.$refs.sdTable && this.$refs.sdTable.doDestroyTable) {
        this.$refs.sdTable.doDestroyTable()
        Vue.prototype.$api.hideIdle()
      }
    },
    onClickbtnSupport: function () {
      console.log('onClickbtnSupport: funct')
      Vue.prototype.$eventHub.$emit('OnSupportShow', true)
    }
  },
  data () {
    return {
      showMe: false,
      pgresults: [],
      bankAnchor: null,
      allTablesData: null,
      currentCurrency: '1',
      selected: null,
      widthSubSet: 20,
      tableNotComplete: false,
      subHeight: 0,
      myEventName: '',
      headers: [],
      result: null,
      'tableConfig': {
        selection: false,
        hideCategories: this.hideCategories,
        hideHintStars: this.hideHintStars,
        header: {
          columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
        },
        rows: {
          rowClass: 'rowEIE'
        }
      }
    }
  },
  created () {
    // Vue.prototype.$eventHub.$on('changeCurrency', this.reload)
    // Vue.prototype.$eventHub.$on('setLocale', this.reload)
  },
  destroyed () {
    // Vue.prototype.$eventHub.$off('changeCurrency', this.reload)
    // Vue.prototype.$eventHub.$off('setLocale', this.reload)
  },
  mounted () {
    this.subHeight = 0
    this.showMe = false
    if (this.heightSub) {
      this.subHeight = this.heightSub
    }
    if (this.widthSub) {
      this.widthSubSet = this.widthSub
    }
    if (this.hideHeader) {
      this.tableConfig.header.columnClass += ' ' // tableHeaderHidden
    }
    this.tableConfig.tableName = this.tableName
    if (this.isClickable) {
      this.tableConfig.isClickable = true
    }
    this.myEventName = this.clickEventName
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/StrukturBilanzTable.vue